import InfoBar from './InfoBar.view';

export default InfoBar;
